import { useState, useEffect } from "react";
import API from "../services/api";
import { setToken, isLoggedIn } from "../utils/auth";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";

import "../assets/login.css";

export default function Login() {
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [step, setStep] = useState(1);
  const [otpId, setOtpId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [country_code, setCountryCode] = useState("+974");
    const [countries, setCountries] = useState([]);


  const navigate = useNavigate();

   useEffect(() => {
    const fetchCountries = async () => {
      try {
        const res = await axios.get("https://realestate.alallamtech.com/demo/api-company/countries/list");
        setCountries(res.data);
        console.log("countries",res.data);
        
      } catch (error) {
        console.error("Error fetching countries", error);
      }
    };
  
    fetchCountries();
  }, []);

  // Redirect if already logged in
  useEffect(() => {
    if (isLoggedIn()) {
      navigate("/dashboard");
    }
  }, [navigate]);

  const validateMobile = (phone) => {
    // Basic validation - adjust according to your needs
    const phoneRegex = /^\d{7,15}$/;
    return phoneRegex.test(phone);
  };

  const handleSendOtp = async () => {
    if (!mobile.trim()) {
      return Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Please enter mobile number",
        showConfirmButton: false,
        timer: 2000,
      });
    }

    if (!validateMobile(mobile)) {
      return Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Please enter a valid mobile number",
        showConfirmButton: false,
        timer: 2000,
      });
    }

    if (!country_code) {
      return Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Please select country code",
        showConfirmButton: false,
        timer: 2000,
      });
    }

    try {
      setLoading(true);
      const res = await API.post("/login", {
        phone_no: mobile.trim(),
        country_code: country_code,
      });

      if (res.data.statuscode === 200) {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: res.data.message || "OTP sent successfully!",
          showConfirmButton: false,
          timer: 2500,
        });

        setOtpId(res.data.hotel_group_master_id);
        setStep(2);
        setOtp(""); // Clear OTP field when moving to step 2
      } else {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "error",
          title: res.data.message || "Failed to send OTP",
          showConfirmButton: false,
          timer: 3000,
        });
      }
    } catch (error) {
      console.error("Send OTP Error:", error);
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Failed to send OTP. Please try again.",
        showConfirmButton: false,
        timer: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async () => {
    if (!otp.trim()) {
      return Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Please enter OTP",
        showConfirmButton: false,
        timer: 2000,
      });
    }

    if (otp.trim().length < 4) {
      return Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "OTP must be at least 4 digits",
        showConfirmButton: false,
        timer: 2000,
      });
    }

    try {
      setLoading(true);
      const res = await API.post("/login/otp", {
        hotel_group_master_id: otpId,
        otp: otp.trim(),
      });

      if (res.data.status === 200) {
        setToken(res.data.token);
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Login successful!",
          showConfirmButton: false,
          timer: 1500,
        });
        navigate("/dashboard");
      } else {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "error",
          title: res.data.message || "Invalid OTP",
          showConfirmButton: false,
          timer: 2500,
        });
      }
    } catch (error) {
      console.error("Verify OTP Error:", error);
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Invalid OTP or session expired",
        showConfirmButton: false,
        timer: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleResendOtp = async () => {
    if (!mobile || !country_code) return;

    try {
      setResendLoading(true);
      const res = await API.post("/login", {
        phone_no: mobile.trim(),
        country_code: country_code,
      });

      if (res.data.statuscode === 200) {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "OTP resent successfully",
          showConfirmButton: false,
          timer: 2000,
        });
        setOtpId(res.data.hotel_group_master_id);
      } else {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "error",
          title: res.data.message || "Failed to resend OTP",
          showConfirmButton: false,
          timer: 2500,
        });
      }
    } catch (error) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Failed to resend OTP",
        showConfirmButton: false,
        timer: 3000,
      });
    } finally {
      setResendLoading(false);
    }
  };

  return (
    <div className="login-wrapper d-flex align-items-center justify-content-center min-vh-100">
      <div className="login-card shadow-lg p-4">
        <div className="text-center mb-4">
          <h2 className="mb-1">Welcome 👋</h2>
          <p className="text-muted">Hotel Admin Login</p>
        </div>

        {step === 1 && (
          <>
            <div className="mb-3 d-flex flex-column flex-md-row gap-2">
              <select className="form-select"
  value={country_code}
  onChange={(e) => setCountryCode(e.target.value)}
>
  <option value="">Select Country</option>

  {countries.map((country) => (
    <option
      key={country.country_master_id}
      value={`+${country.phonecode}`}
    >
      {country.name}({`+${country.phonecode}`})
    </option>
  ))}
</select>

              <input
                type="tel"
                className="form-control"
                placeholder="Mobile number"
                value={mobile}
                onChange={(e) => setMobile(e.target.value.replace(/[^0-9]/g, ""))}
                maxLength={15}
              />
            </div>

            <button
              className="btn btn-primary w-100 login-btn"
              onClick={handleSendOtp}
              disabled={loading}
            >
              {loading ? "Sending OTP..." : "Send OTP"}
            </button>
          </>
        )}

        {step === 2 && (
          <>
            <p className="text-center small text-muted mb-3">
              OTP sent to <strong>{country_code} {mobile}</strong>
            </p>

            <input
              type="text"
              className="form-control mb-3 text-center fs-5"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value.replace(/[^0-9]/g, ""))}
              maxLength={6}
            />

            <button
              className="btn btn-success w-100 login-btn mb-3"
              onClick={handleVerifyOtp}
              disabled={loading}
            >
              {loading ? "Verifying..." : "Verify OTP"}
            </button>

            {/* <div className="d-flex justify-content-center gap-2">
              <p
                className="text-center text-primary change-number mb-0"
                style={{ cursor: "pointer" }}
                onClick={() => setStep(1)}
              >
                Change Number
              </p>

              <span className="text-muted">•</span>

              <p
                className="text-center text-primary mb-0"
                style={{ cursor: "pointer" }}
                onClick={handleResendOtp}
              >
                {resendLoading ? "Resending..." : "Resend OTP"}
              </p>
            </div> */}
          </>
        )}
      </div>
    </div>
  );
}